import { computed, ref } from 'vue'

export interface FilterState {
  number: string | null
  dateCreatedFrom: string | null
  dateCreatedTo: string | null
  dateApprovedFrom: string | null
  dateApprovedTo: string | null
  dateValidUntilFrom: string | null
  dateValidUntilTo: string | null
}

export function useFilters() {
  const activeFilters = ref<FilterState>({
    number: null,
    dateCreatedFrom: null,
    dateCreatedTo: null,
    dateApprovedFrom: null,
    dateApprovedTo: null,
    dateValidUntilFrom: null,
    dateValidUntilTo: null,
  })

  const isNumberFilterActive = computed(() => !!activeFilters.value.number?.trim())

  const isDateCreatedFilterActive = computed(
    () => !!activeFilters.value.dateCreatedFrom || !!activeFilters.value.dateCreatedTo,
  )
  const isDateApprovedFilterActive = computed(
    () => !!activeFilters.value.dateApprovedFrom || !!activeFilters.value.dateApprovedTo,
  )
  const isDateValidUntilFilterActive = computed(
    () =>
      !!activeFilters.value.dateValidUntilFrom
      || !!activeFilters.value.dateValidUntilTo,
  )

  const applyNumberFilter = (value: string | null) => {
    activeFilters.value.number = value?.trim() || null
  }

  const applyDateCreatedFilter = (from: string | null, to: string | null) => {
    activeFilters.value.dateCreatedFrom = from
    activeFilters.value.dateCreatedTo = to
  }

  const applyDateApprovedFilter = (from: string | null, to: string | null) => {
    activeFilters.value.dateApprovedFrom = from
    activeFilters.value.dateApprovedTo = to
  }

  const applyDateValidUntilFilter = (from: string | null, to: string | null) => {
    activeFilters.value.dateValidUntilFrom = from
    activeFilters.value.dateValidUntilTo = to
  }

  const resetAllFilters = () => {
    activeFilters.value = {
      number: null,
      dateCreatedFrom: null,
      dateCreatedTo: null,
      dateApprovedFrom: null,
      dateApprovedTo: null,
      dateValidUntilFrom: null,
      dateValidUntilTo: null,
    }
  }

  return {
    activeFilters,
    isNumberFilterActive,
    isDateCreatedFilterActive,
    isDateApprovedFilterActive,
    isDateValidUntilFilterActive,
    applyNumberFilter,
    applyDateCreatedFilter,
    applyDateApprovedFilter,
    applyDateValidUntilFilter,
    resetAllFilters,
  }
}
